import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {DataAvailabilityCollectionInListModel} from "../models/data-availability-collection-in-list.model";

@Injectable({
  providedIn: 'root'
})
export class DataAvailabilityService {

  private url = `${environment.apiURL}/data-availability`;
  collectionDataAvailabilitySubject = new BehaviorSubject<DataAvailabilityCollectionInListModel[]>([]);

  constructor(
    private http: HttpClient
  ) {
  }

  public collectionAvailableDataByCollectionVariables(requestBody: {
    [collectionName: string]: string[]
  }): Observable<any> {
    return this.http.post(`${this.url}/collection-available-data/collection-variables`, requestBody);
  }

  public collectionAvailableDataByCollectionTitle(collectionTitle: string): Observable<any> {
    return this.http.post(`${this.url}/collection-available-data/collection`, {collection: collectionTitle});
  }

}
